import { render, staticRenderFns } from "./StatusSegment.vue?vue&type=template&id=2b3244c9&scoped=true&"
import script from "./StatusSegment.vue?vue&type=script&lang=js&"
export * from "./StatusSegment.vue?vue&type=script&lang=js&"
import style0 from "./StatusSegment.vue?vue&type=style&index=0&id=2b3244c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3244c9",
  null
  
)

export default component.exports